/**
 * Created by claude on 2/13/26
 */

const Merge3SlotSetup = function (slot) {
    slot.keyOverrides = {
        "fogs": DataLoader.TYPES.FOGS,
        "harvested": DataLoader.TYPES.HARVESTED,
        "workers": DataLoader.TYPES.WORKERS,
        "quests": DataLoader.TYPES.QUESTS,
        "unitslibrary": DataLoader.TYPES.UNITS_LIBRARY,
        "lives": DataLoader.TYPES.LIVES,
        "local_map2d": DataLoader.TYPES.MAP2D,
        "local_scroll": DataLoader.TYPES.SCROLL,
        "local_free_worker": DataLoader.TYPES.FREE_WORKER,
        "local_growings_planner": DataLoader.TYPES.GROWINGS_PLANNER,
        "local_pixel_planner": DataLoader.TYPES.PIXELS_PLANNER,
        "local_thirdelements_planner": DataLoader.TYPES.THIRDELEMENTS_PLANNER,
        "local_barrel_planner": DataLoader.TYPES.BARREL_PLANNER,
        "local_monster_planner": DataLoader.TYPES.MONSTER_PLANNER,
        "local_pathindicator_cell": DataLoader.TYPES.PATHINDICATOR_CELL
    };

    slot.localKeyPrefix = cleverapps.dataLoader.getLocalStoragePrefix();

    const storedGameKey = `${slot.localKeyPrefix}_level_0x${slot.slotId || 0}`;
    let storedGame = cleverapps.dataLoader.load(storedGameKey) || {};

    const saveStoredGame = function (fromServer) {
        cleverapps.dataLoader.save(storedGameKey, storedGame);

        if (!fromServer) {
            connector.synchronizer.addSendTask(`games${slot.slotId}`);
        }
    };

    slot.updateGameInfo = function (serverData) {
        if (serverData === undefined) {
            return;
        }

        delete serverData.episode;
        delete serverData.level;

        storedGame = serverData;

        saveStoredGame(true);
    };

    slot.getGameInfo = function () {
        const stored = { ...storedGame };

        let episodeNo, levelNo;

        if (slot.slotId === "1" || slot.slotId === "2") { // backward compatibility since 29.06.20203
            episodeNo = slot.slotId;
        }

        if (Object.keys(stored).length > 0) {
            stored.episode = episodeNo;
            stored.level = levelNo;
        }

        return stored;
    };

    slot.loadFromStorage = function (key, options) {
        if (!slot.isLocalKey(key) && !UniversalSlot.keysToTable[key]) {
            return storedGame[key];
        }
        return cleverapps.dataLoader.load(slot.storeKey(key), options);
    };

    slot.saveToStorage = function (key, info, fromServer) {
        if (!slot.isLocalKey(key) && !UniversalSlot.keysToTable[key]) {
            if (cleverapps.isEmpty(info)) {
                delete storedGame[key];
            } else {
                storedGame[key] = info;
            }
            saveStoredGame(fromServer);
            return;
        }
        UniversalSlot.prototype.saveToStorage.call(slot, key, info, fromServer);
    };

    slot.resetStorage = function () {
        storedGame = {};
        saveStoredGame();
    };
};

UniversalSlot.HANDLER_FACTORIES.workers = (slot) => ({
    load: () => {
        const stored = cleverapps.dataLoader.load(slot.storeKey("workers"));
        return stored && !Array.isArray(stored) ? stored : {};
    },
    save: (info, fromServer) => {
        cleverapps.dataLoader.save(slot.storeKey("workers"), info);
        if (!fromServer) {
            connector.synchronizer.addSendTask(`workers${slot.slotId}`);
        }
    },
    reset: () => {
        cleverapps.dataLoader.save(slot.storeKey("workers"), {});
        connector.synchronizer.addSendTask(`workers${slot.slotId}`);
    }
});

UniversalSlot.HANDLER_FACTORIES.lives = (slot) => ({
    reset: () => {
        if (slot.slotId === Meta.SLOT_MAIN) {
            LivesHelper.GetMainInstance().reset();
        }
    }
});

UniversalSlot.keysToTable["lives"] = "lives";

UniversalSlot.registerTable("fogs", {
    getInfo: (slot) => slot.load("fogs") || [],
    updateInfo: (slot, serverData) => slot.save("fogs", serverData, true)
});

SyncAdapters.registerBySlots("games", {
    getInfo: (slotId) => cleverapps.dataSlots.getSlot(slotId).getGameInfo(),
    updateInfo: (slotId, serverGame) => cleverapps.dataSlots.getSlot(slotId).updateGameInfo(serverGame)
});

SyncAdapters.registerBySlots("lives", {
    getInfo: (slotId) => (slotId === Meta.SLOT_MAIN
        ? LivesHelper.GetMainInstance().getInfo()
        : cleverapps.dataSlots.getSlot(slotId).load("lives")),
    updateInfo: (slotId, serverData) => (slotId === Meta.SLOT_MAIN
        ? LivesHelper.GetMainInstance().updateInfo(serverData, true)
        : cleverapps.dataSlots.getSlot(slotId).save("lives", serverData, true))
});
